import React from 'react';
import { Link } from 'react-router-dom';
import FirmwareUpload from '../components/FirmwareUpload';
import '../App.css';

function Oled() {
  return (
    <div className="page-shell">
      <h3>OLED</h3>
      <p>&nbsp;</p>
      <p className="page-lead">自发光、轻薄、超薄、高对比度、可柔性、响应快、视角广、功耗低的下一代显示技术。OLED，Organic Light-Emitting Diode，又称有机电激光显示、有机发光半导体，一种电流型有机发光器件。</p>
      <p>自发光原理：OLED 屏幕每个像素点都是独立的微型光源，通电后有机材料直接发光，不需要像 LCD 那样依赖背光层。</p>
      <p>结构组成：由基板、阳极、有机功能层和阴极多层薄膜构成，厚度可小于 1 毫米。</p>
      <p>驱动方式：分为被动式（PMOLED）和主动式（AMOLED），手机和电视主要用 AMOLED，功耗更低、适合大尺寸。</p>
      <p>&nbsp;</p>
      <p>OTA 升级，请移至公布的新平台。</p>
      {/*
      <p>OTA 远程升级固件上传：</p>
      <FirmwareUpload category="oled" label="上传 OLED 固件" />
      */}
      <p>&nbsp;</p>
      <div className="page-actions">
        <Link to="/gallery/oled" className="link-card" title="设备列表">OLED 屏设备列表</Link>
      </div>
    </div>
  );
}
export default Oled;